import { media } from '@mgmresorts/wcl-styled';
import styled from 'styled-components';

export const Container = styled.div<{ width?: string; height?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 182px;
  margin: auto;
  width: ${(props: { width?: string }) => props.width || '700px'};
  height: ${(props: { height?: string }) => props.height || '540px'};

  ${media.md`
    width: 100%;
    height: auto;
    padding: 32px;
    box-shadow: none;
    min-height: 100%;
  `}

  ${media.sm`
    width: 100%;
    height: auto;
    padding: 32px;
    box-shadow: none;
    min-height: 100%;
  `}

  /* Container/Card */
  background: #ffffff;
  border-radius: 10px;

  > div,
  button {
    align-self: stretch;
  }
`;
